export default __webpack_public_path__ + "static/media/bg-cod-2.fa948c54.png";